"use client";

import React, { createContext, useContext, useState, useCallback } from "react";
import { Message } from "@/lib/core/crm/types";

interface ReplyContextType {
  replyingToMessage: Message | null;
  setReplyingToMessage: (message: Message | null) => void;
}

const ReplyContext = createContext<ReplyContextType | undefined>(undefined);

export function ReplyProvider({ children }: { children: React.ReactNode }) {
  const [replyingToMessage, setReplyingToMessage] = useState<Message | null>(null);

  return (
    <ReplyContext.Provider value={{ replyingToMessage, setReplyingToMessage }}>
      {children}
    </ReplyContext.Provider>
  );
}

export function useReplyContext() {
  const context = useContext(ReplyContext);
  if (!context) {
    throw new Error("useReplyContext must be used within a ReplyProvider");
  }
  return context;
}
